import React from 'react';

const collectNWin = "Collect 'N Win";

const PAGE_TITLE_SUFFIX = ' - New York Lottery';

const copyDefaults = {
  login: {
    header: `Log in to New York Lottery${PAGE_TITLE_SUFFIX}`,
    body: `Ready to play and win? Use your existing ${collectNWin} credentials to access all the exciting features of the updated app. Log in now and start playing!`,
    line2: `(If you have a ${collectNWin} account, use those credentials to join in all the fun of NYL+.)`,
  },
  register: {
    header: `Welcome to the New York Lottery Registration Page!${PAGE_TITLE_SUFFIX}`,
    body: 'Create an account and join the NYL+ program, featuring fun second chance games and exclusive promotions with more chances to win cash, gift cards, and other prizes.. (Fields with asterisks are required.)',
    preLinkText: `Are you a ${collectNWin} User? `,
    linkText: 'Log in',
    postLinkText: ' to NYL+ with your existing credentials.',
    linkUrl: '/login',
  },
  completeRegistration: {
    header: `Complete your account setup${PAGE_TITLE_SUFFIX}`,
    body: 'Enter your information below to finish creating your NYL+ account and access exclusive promotions, second chance games, and more ways to win. Please ensure your legal name, address, phone number, and date of birth are entered accurately as required fields for account verification.',
  },
  resetPassword: {
    header: `Reset Your Password${PAGE_TITLE_SUFFIX}`,
    pageTitle: `Reset Password${PAGE_TITLE_SUFFIX}`,
    body: `Enter the email address associated with your NYL+ account (formerly your ${collectNWin} or your current Official NY Lottery account). If you\'re registered, we\'ll send you an email with instructions for resetting your password.`,
  },
  confirmResetPassword: {
    header: `Reset password confirmation${PAGE_TITLE_SUFFIX}`,
    pageTitle: `Reset Password Confirmation${PAGE_TITLE_SUFFIX}`,
    body: 'Please enter your new password and confirm in the fields below. Then press RESET PASSWORD',
  },
  checkEmail: {
    header: `Check Your Email${PAGE_TITLE_SUFFIX}`,
    routedTitleSection: false,
    body: "We've sent a verification email to your inbox. Your link should arrive within the next few minutes. Open the email and follow the instructions to continue.",
    resendHelperPre: "Didn't receive the email? Select ",
    resendHelperBold: 'Resend Email',
    resendHelperPost: ' to get a new link.',
    resendSuccess: 'A new verification email has been sent.',
    resendFailure: "We couldn't send a new email. Please try again.",
    resendCooldown: 'You can resend again in {seconds} seconds.',
    resendSystemError: 'The system is experiencing a problem, please try again soon.',
  },
  verifyEmail: {
    routedTitleSection: false,
    pageTitle: `Verify Email${PAGE_TITLE_SUFFIX}`,
    header: 'Congratulations!',
    body: "Your email address has been confirmed. You're one step closer to completing your registration.",
    line2: 'Click below to continue setting up your account.',
    continueLabel: 'Continue',
    failureMessage:
      'We were unable to verify your email. Please try again or request a new verification link.',
  },
  updateProfile: {
    header: 'Update Profile',
    pageTitle: `Update Profile${PAGE_TITLE_SUFFIX}`,
    body: 'Update your profile here.',
  },
  migrateProfile: {
    header: 'Please verify your account details',
    body: 'Confirm your information below to finish updating your NYL+ account.',
    line2: 'Please verify that all the required fields are current and accurate to proceed.',
  },
  migrationFailed: {
    header: '',
    pageTitle: `Identity Verification${PAGE_TITLE_SUFFIX}`,
    body: '',
  },
  migrationSuccess: {
    header: 'Success! Welcome to NYL+',
    routedTitleSection: false,
    body: 'Your account has been successfully created. You now have access to exclusive NYL+ promotions, second chance games, and more ways to play.',
    exploreLabel: 'Explore NYL+',
  },
  userDuplicated: {
    header: '',
    pageTitle: `Account Exists${PAGE_TITLE_SUFFIX}`,
    body: '',
  },
  identityVerification: {
    header: 'Identity Verification',
    routedTitleSection: false,
    body: "To set up your account, we'll need to verify your identity. Please have the following ready:",
    requirements: [
      "A U.S. driver's license/ID card, or an international government-issued passport/ID card",
      'A mobile device with a camera',
    ],
    cardHeading: 'Proceed to verify your identity',
    cardBody:
      "You will be directed to our secure identity verification partner and may be asked to take photos using your mobile device's camera to complete verification.",
    continueLabel: 'Continue',
  },
  govIdResponse: {
    header: '',
    pageTitle: `ID Verification${PAGE_TITLE_SUFFIX}`,
    body: '',
  },
};

export const getCopy = (path) => {
  if (path.includes('login')) {
    return copyDefaults.login;
  } else if (path.includes('complete-registration')) {
    return copyDefaults.completeRegistration;
  } else if (path.includes('register')) {
    return copyDefaults.register;
  } else if (path.includes('reset-password') && !path.includes('confirm-')) {
    return copyDefaults.resetPassword;
  } else if (path.includes('confirm-reset-password')) {
    return copyDefaults.confirmResetPassword;
  } else if (path.includes('check-email')) {
    return copyDefaults.checkEmail;
  } else if (path.includes('verify-email')) {
    return copyDefaults.verifyEmail;
  } else if (path.includes('idv/migrate')) {
    return copyDefaults.migrateProfile;
  } else if (path.includes('update-profile')) {
    return copyDefaults.updateProfile;
  } else if (path.includes('idv/success')) {
    return copyDefaults.migrationSuccess;
  } else if (path.includes('idv/failed')) {
    return copyDefaults.migrationFailed;
  } else if (path.includes('idv/identity-verification')) {
    return copyDefaults.identityVerification;
  } else if (path.includes('gov-id-response')) {
    return copyDefaults.govIdResponse;
  } else if (path.includes('user-duplicated')) {
    return copyDefaults.userDuplicated;
  }
  return copyDefaults.register;
};

export const getPageTitle = (path) => {
  const copy = getCopy(path);
  if (copy.pageTitle) return copy.pageTitle;
  if (copy.header) return `${copy.header}${PAGE_TITLE_SUFFIX}`;
  return null;
};
